import moment from "moment-timezone";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import FinishedDialog from "../../components/FinishedDialog";
import CheckInDialog from "../../components/settings/CheckInDialog";
import InAppDialog from "../../components/settings/InAppDialog";
import LiveLinkDialog from "../../components/settings/LiveLinkDialog";
import LiveLinkSettings from "../../components/settings/LiveLinkSettings";
import NotificationsDialog from "../../components/settings/NotificationsDialog";
import QRCodeDialog from "../../components/settings/QRCodeDialog";
import UpgradeDialog from "../../components/UpgradeDialog";
import UpgradeStatusDialog from "../../components/UpgradeStatusDialog";
import { languages } from "../../constants/languages";
import { addToAp } from "../../util/AddToApp";

class SettingsContainer extends Component {
  state = {
    liveLinkDialogOpen: false,
    liveLink: "",
    errorMessage: "",
    errorMessagePouleStandings: "",
    checkingLiveLink: false,
    finishedDialogOpen: false,
    numVisits: null,
    numVisitsApp: null,
    tournamentHasPlayers: false,
    playersLoaded: false,
    checkInDialogOpen: false,
    checkInStart: "",
    checkInEnd: "",

    qrCodeDialogOpen: false,
    notificationsDialogOpen: false,
    minutes: 15,
    hours: 0,
    daysByKey: {},
    sportParks: [],

    upgradeDialogOpen: false,
    inAppDialogOpen: false,
    addingToApp: false,
  };

  toggleInAppDialog = () => {
    this.setState({
      inAppDialogOpen: !this.state.inAppDialogOpen,
    });
  };

  removeFromApp = () => {
    const db = window.firebase.firestore();
    let batch = db.batch();
    batch.delete(
      db.collection("tournamentSearch").doc(this.props.tournament[".key"])
    );
    batch.update(
      db.collection("tournaments").doc(this.props.tournament[".key"]),
      {
        ia: false,
      }
    );
    batch.commit();
  };

  handleInAppSubmit = (e) => {
    e.preventDefault();
    this.setState({ addingToApp: true });
    addToAp(this.props.tournament[".key"]).then(() => {
      this.setState({ addingToApp: false, inAppDialogOpen: false });
    });
  };

  toggleUpgradeDialog = () => {
    if (!this.state.upgradeDialogOpen) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("paywall_add_to_app");
      }
      // mailer lite paywall seen
      window.firebase
        .firestore()
        .collection("paywallSeenRequests")
        .doc()
        .set({ uid: this.props.user.uid });
    }
    this.setState({ upgradeDialogOpen: !this.state.upgradeDialogOpen });
  };

  handleNotificationSubmit = (e) => {
    e.preventDefault();
    const db = window.firebase.firestore();
    let batch = db.batch();

    let toUpdate = {};
    toUpdate["nH"] = this.state.hours;
    toUpdate["nM"] = this.state.minutes;
    batch.update(
      db.collection("tournaments").doc(this.props.tournament[".key"]),
      toUpdate
    );
    Object.keys(this.props.tournament.fields || {}).forEach((fieldKey) => {
      batch.set(db.collection("cacheUpdatesForField").doc(), {
        tournamentId: this.props.tournament[".key"],
        fieldId: fieldKey,
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    });
    let minutes = this.state.hours * 60 + this.state.minutes;
    Object.keys(this.props.tournament.roundTimes || {}).forEach((key) => {
      let roundTime = this.props.tournament.roundTimes[key];
      if (roundTime.time) {
        const roundNotificationsRef = db.collection("roundNotifications");

        let dateString = moment
          .unix(
            roundTime.day !== "0"
              ? (this.state.daysByKey[roundTime.day] || {}).date ||
                  this.props.tournament.date
              : this.props.tournament.date
          )
          .tz(this.props.tournament.timezone || "Europe/Amsterdam")
          .format("YYYY-MM-DD");

        batch.set(
          roundNotificationsRef.doc(this.props.tournament[".key"] + key),
          {
            startTimeStamp: moment
              .tz(
                dateString + " " + roundTime.time,
                "YYYY-MM-DD HH:mm",
                this.props.tournament.timezone || "Europe/Amsterdam"
              )
              .unix(),
            sendTimeStamp: moment
              .tz(
                dateString + " " + roundTime.time,
                "YYYY-MM-DD HH:mm",
                this.props.tournament.timezone || "Europe/Amsterdam"
              )
              .subtract(minutes, "m")
              .unix(),
            st: roundTime.time,
            et: "",
            tournamentId: this.props.tournament[".key"],
            sent: false,
            roundNum: Number(key),
          }
        );
      }
    });
    batch.commit();
    this.toggleNotificationsDialog();
  };

  handleNotificationChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    if (e.target.name === "hours" && e.target.value === 24) {
      toUpdate["minutes"] = 0;
    }
    this.setState(toUpdate);
  };

  toggleQRCodeDialog = () => {
    this.setState({ qrCodeDialogOpen: !this.state.qrCodeDialogOpen });
  };

  toggleNotificationsDialog = () => {
    this.setState({
      notificationsDialogOpen: !this.state.notificationsDialogOpen,
    });
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  UNSAFE_componentWillMount = () => {
    let newState = {
      liveLink: this.props.tournament.liveLink || "",
      checkInStart: this.props.tournament.checkInStart || "",
      checkInEnd: this.props.tournament.checkInEnd || "",
      hours:
        this.props.tournament.nH !== undefined ? this.props.tournament.nH : 0,
      minutes:
        this.props.tournament.nM !== undefined ? this.props.tournament.nM : 15,
    };

    this.setState(newState);

    this.unsubscribe = window.firebase
      .firestore()
      .collection("visitors")
      .doc(this.props.tournament[".key"])
      .onSnapshot((doc) => {
        let data = doc.data();
        this.setState({
          numVisits: (data || {}).numVisits || 0,
        });
      });

    this.unsubscribe = window.firebase
      .firestore()
      .collection("visitorsApp")
      .doc(this.props.tournament[".key"])
      .onSnapshot((doc) => {
        let data = doc.data();
        this.setState({
          numVisitsApp: (data || {}).visitors || 0,
        });
      });

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    this.unsubscribePlayers = tournamentRef
      .collection("players")
      .onSnapshot((querySnapshot) => {
        let players = [];
        querySnapshot.forEach((doc) => {
          let player = doc.data();
          player["id"] = doc.id;
          players.push(player);
        });
        this.setState({
          tournamentHasPlayers: players.length > 0,
          playersLoaded: true,
        });
      });
    this.unsubscribeDays = tournamentRef
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let daysByKey = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          daysByKey[doc.id] = day;
        });
        this.setState({
          daysByKey: daysByKey,
        });
      });
    this.unsubscribeSportParks = tournamentRef
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
        });
        this.setState({
          sportParks: sportParks.sort((a, b) => {
            if (a.num > b.num) return 1;
            if (a.num < b.num) return -1;
            if (Number(a.id) > Number(b.id)) return 1;
            if (Number(a.id) < Number(b.id)) return -1;
            return 0;
          }),
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
    this.unsubscribePlayers();
    this.unsubscribeDays();
    this.unsubscribeSportParks();
  };

  handleShowPageChange = (e) => {
    let toUpdate = {};
    if (
      this.props.tournament[e.target.name] === undefined &&
      e.target.name !== "showRefereeSchedule" &&
      e.target.name !== "showSignupPage" &&
      e.target.name !== "showRankingInStandings" &&
      e.target.name !== "use12HTime" &&
      e.target.name !== "showCriteria"
    ) {
      toUpdate[e.target.name] = false;
    } else {
      toUpdate[e.target.name] = !this.props.tournament[e.target.name];
    }
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleShowPageCheck = (e, pageId) => {
    let toUpdate = {};
    if (
      this.props.tournament[pageId] === undefined &&
      pageId !== "showRefereeSchedule" &&
      pageId !== "showSignupPage" &&
      pageId !== "showRankingInStandings"
    ) {
      toUpdate[pageId] = false;
    } else {
      toUpdate[pageId] = !this.props.tournament[pageId];
    }
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  toggleLiveLinkDialog = () => {
    this.setState({ liveLinkDialogOpen: !this.state.liveLinkDialogOpen });
  };
  handleLiveLinkChange = (e) => {
    let liveLink = e.target.value.toLowerCase();
    if (/^([a-z0-9](-?))*$/.test(liveLink)) {
      this.setState({ liveLink: liveLink });
    }
  };
  handleSubmitLiveLink = (e) => {
    e.preventDefault();
    this.setState({ errorMessage: "", checkingLiveLink: true });

    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    let batch = db.batch();
    batch.update(tournamentRef, { liveLink: this.state.liveLink });
    if (this.state.liveLink.length > 0) {
      batch.set(db.collection("liveLinks").doc(this.state.liveLink), {
        tournamentId: this.props.tournament[".key"],
      });
      db.collection("liveLinks")
        .doc(this.state.liveLink)
        .get()
        .then((doc) => {
          if (doc.exists) {
            if (doc.data().tournamentId === this.props.tournament[".key"]) {
              // current tournament, save link
              this.setState({ checkingLiveLink: false });
              this.toggleLiveLinkDialog();
            } else {
              // error: link already exists
              this.setState({
                errorMessage: languages.tournament.liveLinkAlreadyExists,
                checkingLiveLink: false,
              });
            }
          } else {
            // link is new
            // check for existing link for this tournament
            db.collection("liveLinks")
              .where("tournamentId", "==", this.props.tournament[".key"])
              .limit(1)
              .get()
              .then((querySnapshot) => {
                if (this.props.tournament.liveLink === undefined) {
                  if (window.firebase.analytics) {
                    window.firebase.analytics().logEvent("livelink_created");
                  }
                  // mailer lite livelink created
                  window.firebase
                    .firestore()
                    .collection("livelinkCreatedRequests")
                    .doc()
                    .set({ uid: this.props.user.uid });
                }
                if (querySnapshot.empty) {
                  // no existing link
                  batch.commit().then(() => {
                    this.setState({ checkingLiveLink: false });
                    this.toggleLiveLinkDialog();
                  });
                } else {
                  querySnapshot.forEach((doc) => {
                    // delete existing link
                    batch.delete(db.collection("liveLinks").doc(doc.id));
                  });
                  batch.commit().then(() => {
                    this.setState({ checkingLiveLink: false });
                    this.toggleLiveLinkDialog();
                  });
                }
              });
          }
        });
    } else {
      // check for existing link for this tournament
      db.collection("liveLinks")
        .where("tournamentId", "==", this.props.tournament[".key"])
        .limit(1)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            // no existing link
            batch.commit().then(() => {
              this.setState({ checkingLiveLink: false });
              this.toggleLiveLinkDialog();
            });
          } else {
            querySnapshot.forEach((doc) => {
              // delete existing link
              batch.delete(db.collection("liveLinks").doc(doc.id));
            });
            batch.commit().then(() => {
              this.setState({ checkingLiveLink: false });
              this.toggleLiveLinkDialog();
            });
          }
        });
    }
  };

  handleChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };
  handleDateChange = (date) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.toggleFinishedDialog();
    } else {
      const timestamp = date.unix();
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update({ date: timestamp });
    }
  };
  handleEndDateChange = (date) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.toggleFinishedDialog();
    } else {
      const timestamp = date.unix();
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update({ endDate: timestamp });
    }
  };

  handleToSignup = () => {
    this.props.history.push(
      "/tournament/" + this.props.tournament[".key"] + "/signup"
    );
    if (window) {
      window.scrollTo(0, 0);
    }
  };

  handleToTournamentInfo = () => {
    this.props.history.push(
      "/tournament/" + this.props.tournament[".key"] + "/info"
    );
    if (window) {
      window.scrollTo(0, 0);
    }
  };

  handleCheck = (e, screen, type) => {
    let pouleStandings = this.props.tournament.pouleStandings || {};
    let normal = pouleStandings.normal || {};
    let mobile = pouleStandings.mobile || {};
    let numNormal = 0;
    let numMobile = 0;
    let defaultFields = [
      "G",
      "W",
      "GL",
      "V",
      "P",
      "SV",
      "ST",
      "S+/-",
      "DPV",
      "DPT",
      "+/-",
    ];
    let defaultCheckedNormal = ["G", "W", "GL", "V", "P", "DPV", "DPT", "+/-"];
    let defaultCheckedMobile = ["G", "P", "+/-"];
    let customFields = Object.keys(this.props.tournament.customPoints || {});
    defaultFields.forEach((f) => {
      if (
        (defaultCheckedNormal.indexOf(f) !== -1 &&
          ((normal.default || {})[f] ||
            (normal.default || {})[f] === undefined)) ||
        (defaultCheckedNormal.indexOf(f) === -1 && (normal.default || {})[f])
      ) {
        numNormal++;
      }
      if (
        (defaultCheckedMobile.indexOf(f) !== -1 &&
          ((mobile.default || {})[f] ||
            (mobile.default || {})[f] === undefined)) ||
        (defaultCheckedMobile.indexOf(f) === -1 && (mobile.default || {})[f])
      ) {
        numMobile++;
      }
    });
    customFields.forEach((f) => {
      if (
        (normal.custom || {})[f] &&
        (this.props.tournament.customPoints || {})[f]
      ) {
        numNormal++;
      }
      if (
        (mobile.custom || {})[f] &&
        (this.props.tournament.customPoints || {})[f]
      ) {
        numMobile++;
      }
    });
    let validCheck =
      e.target.checked === false ||
      (screen === "normal" && numNormal < 8) ||
      (screen === "mobile" && numMobile < 3);

    if (validCheck) {
      let newStandings = pouleStandings;
      if (newStandings[screen] === undefined) {
        newStandings[screen] = {};
      }
      if (newStandings[screen][type] === undefined) {
        newStandings[screen][type] = {};
      }
      newStandings[screen][type][e.target.name] = e.target.checked;
      const tournamentRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      tournamentRef.update({ pouleStandings: newStandings });
      this.setState({
        errorMessagePouleStandings: "",
      });
    } else {
      // error: maximum number of columns already selected
      this.setState({
        errorMessagePouleStandings:
          languages.tournament.pouleStandingsMaxReached,
      });
    }
  };

  handleRequireCheckInChange = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ requireCheckIn: !this.props.tournament.requireCheckIn });
  };

  handleSubmitPreviousChange = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({
        submitPreviousBeforeSubmit:
          this.props.tournament.submitPreviousBeforeSubmit !== undefined
            ? !this.props.tournament.submitPreviousBeforeSubmit
            : false,
      });
  };

  handleRequireEvidenceChange = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ requireEvidence: !this.props.tournament.requireEvidence });
  };

  handleCheckInStartTimeChange = (value) => {
    let newState = {};
    newState["checkInStart"] = value ? value.format("HH:mm") : "";
    this.setState(newState);
  };

  handleCheckInEndTimeChange = (value) => {
    let newState = {};
    newState["checkInEnd"] = value ? value.format("HH:mm") : "";
    this.setState(newState);
  };

  handleCheckInTimesSubmit = (e) => {
    e.preventDefault();
    this.toggleCheckInDialog();
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({
        checkInStart: this.state.checkInStart,
        checkInEnd: this.state.checkInEnd,
      });
  };

  handleSwitch = (e, checked) => {
    let toUpdate = {};
    toUpdate[e.target.name] = checked;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  toggleCheckInDialog = () => {
    this.setState({ checkInDialogOpen: !this.state.checkInDialogOpen });
  };

  render() {
    let allowedToAddToApp = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToAddToApp = true;
    }

    let standingColumns = ["G", "W", "GL", "V", "P", "DPV", "DPT", "+/-"];
    let showSetColumns = (this.props.tournament.useSets || "0") === "1";
    if (showSetColumns) {
      standingColumns = [
        "G",
        "W",
        "GL",
        "V",
        "P",
        "SV",
        "ST",
        "S+/-",
        "DPV",
        "DPT",
        "+/-",
      ];
    }

    return (
      <div>
        <FinishedDialog
          open={this.state.finishedDialogOpen}
          handleClose={this.toggleFinishedDialog}
        />
        <LiveLinkDialog
          open={this.state.liveLinkDialogOpen}
          errorMessage={this.state.errorMessage}
          checkingLiveLink={this.state.checkingLiveLink}
          liveLink={this.state.liveLink}
          toggleDialog={this.toggleLiveLinkDialog}
          handleLiveLinkChange={this.handleLiveLinkChange}
          handleSubmit={this.handleSubmitLiveLink}
          tournament={this.props.tournament}
        />
        <NotificationsDialog
          open={this.state.notificationsDialogOpen}
          toggleDialog={this.toggleNotificationsDialog}
          handleChange={this.handleNotificationChange}
          handleSubmit={this.handleNotificationSubmit}
          minutes={this.state.minutes}
          hours={this.state.hours}
        />
        <CheckInDialog
          open={this.state.checkInDialogOpen}
          checkInStart={this.state.checkInStart}
          checkInEnd={this.state.checkInEnd}
          toggleDialog={this.toggleCheckInDialog}
          handleCheckInStartTimeChange={this.handleCheckInStartTimeChange}
          handleCheckInEndTimeChange={this.handleCheckInEndTimeChange}
          handleSubmit={this.handleCheckInTimesSubmit}
          title={languages.tournament.checkInTimes}
        />
        <QRCodeDialog
          open={this.state.qrCodeDialogOpen}
          toggleDialog={this.toggleQRCodeDialog}
          title={languages.tournament.qrCode}
          tournament={this.props.tournament}
        />
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
        <InAppDialog
          tournament={this.props.tournament}
          open={this.state.inAppDialogOpen}
          toggleDialog={this.toggleInAppDialog}
          handleSubmit={this.handleInAppSubmit}
          addingToApp={this.state.addingToApp}
        />
        {this.props.liveLinkSettings && this.state.playersLoaded ? (
          <LiveLinkSettings
            tournament={this.props.tournament}
            handleChange={this.handleChange}
            toggleLiveLinkDialog={this.toggleLiveLinkDialog}
            handleShowPageChange={this.handleShowPageChange}
            user={this.props.user}
            handleToSignup={this.handleToSignup}
            handleToTournamentInfo={this.handleToTournamentInfo}
            handleCheck={this.handleCheck}
            numVisits={this.state.numVisits}
            numVisitsApp={
              this.state.numVisitsApp ? this.state.numVisitsApp.length : 0
            }
            tournamentHasPlayers={this.state.tournamentHasPlayers}
            handleRequireCheckInChange={this.handleRequireCheckInChange}
            handleRequireEvidenceChange={this.handleRequireEvidenceChange}
            // handleCheckInTimeChange={this.handleCheckInTimeChange}
            toggleCheckInDialog={this.toggleCheckInDialog}
            toggleQRCodeDialog={this.toggleQRCodeDialog}
            handleShowPageCheck={this.handleShowPageCheck}
            handleSubmitPreviousChange={this.handleSubmitPreviousChange}
            toggleNotificationsDialog={this.toggleNotificationsDialog}
            allowedToAddToApp={allowedToAddToApp}
            toggleUpgradeDialog={this.toggleUpgradeDialog}
            toggleInAppDialog={this.toggleInAppDialog}
            removeFromApp={this.removeFromApp}
            handleSwitch={this.handleSwitch}
            showSetColumns={showSetColumns}
            standingColumns={standingColumns}
            errorMessagePouleStandings={this.state.errorMessagePouleStandings}
            daysByKey={this.state.daysByKey}
            sportParks={this.state.sportParks}
          />
        ) : null}
        {this.props.upgrade && (
          <UpgradeStatusDialog tournament={this.props.tournament} />
        )}
      </div>
    );
  }
}

export default withRouter(SettingsContainer);
